import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

export const zodLedgerAccountsSearchSchema = z.object({
  ledgerAccountId: z.uuid().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).catch(PAGINATION_PAGE_SIZE_LARGE),
  page: z.number().int().min(0).catch(0),
  savedFilterId: z.uuid().optional().catch(undefined),
});

export const defaultLedgerAccountsSearch = zodLedgerAccountsSearchSchema.parse(
  {},
);

export type LedgerAccountsSearch = z.infer<
  typeof zodLedgerAccountsSearchSchema
>;
